// extracted by mini-css-extract-plugin
export default {"skip":"styles_skip__w1t76","title":"styles_title__tK5vE"};